(function (factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery', 'moment'], factory);
  } else if (typeof exports === 'object') {
    module.exports = factory(require('jquery'), require('moment'));
  } else {
    factory(jQuery, moment);
  }
}(function ($, moment) {
  if (typeof $.fullCalendar !== 'undefined') {
    $.fullCalendar.datepickerLocale = $.fullCalendar.datepickerLocale || function () { };
    $.fullCalendar.locale("de", {
      buttonText: {
        today: "Heute", // ✅ hinzugefügt
        month: "Monat",
        week: "Woche",
        day: "Tag",
        list: "Terminübersicht"
      },
      allDayText: "Ganztägig",
      eventLimitText: function (n) {
        return "+ weitere " + n;
      },
      noEventsMessage: "Keine Ereignisse anzuzeigen",
      weekLabel: "KW",
      firstDay: 1,
      monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"],
      monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
      dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
      dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"]
    });
  }
}));
